


























import Vue from "vue";
import { openScheme, getScheme } from "@/utils/openUrl";
import { formatNum, formatDuration } from "@/utils/format";
import { cutImage } from "@/utils/img";

export default Vue.extend({
  name: "VideoCard",
  props: {
    aid: {
      type: [String, Number]
    },
    cover: {
      type: String
    },
    view: {
      type: Number
    },
    danmu: {
      type: Number
    },
    duration: {
      type: Number
    },
    desc: {
      type: String
    }
  },
  filters: {
    formatNum, formatDuration
  },
  methods: {
    jump() {
      const scheme = getScheme("video", this.aid);
      openScheme(scheme);
    },
    cutImage(url: string, width: number): string {
      return cutImage(url, width);
    }
  }
});
